<div class="recall-dialog-container">
    <div class="Order-dialog-header-container">
        <div><p class="recall-dialog-header-text recall-section-headers">RECALL ORDER?</p></div>
        <div><p class="recall-dialog-sub-heading">Are you sure you want to recall this order? It will be removed from the approver's queue and returned to you for editing.</p></div>
    </div>

    <div class="recall-btn-dialog-container">

        <button class="cancel-recall-dialog-btn" mat-flat-button type="button" (click)="cancel()">
            <div class="cancel-recall-btn-content">
                <span><p class="cancel-recall-btn-text">CANCEL</p></span>
            </div>
        </button>

        <button class="recall-confirm-btn" mat-flat-button type="button" (click)="confirm()">
            <div class="recall-confirm-btn-content">
                <span><p class="recall-confirm-btn-text">RECALL</p></span>
            </div>
        </button>
    </div>
</div>
